import React, { useEffect, useState,useRef,useContext } from 'react';
import { Link } from 'react-router-dom';
import HeaderBest from './header';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function Aboutt() {
  const [currentTestimonial, setCurrentTestimonial] = useState(0);
    const brandData = [
      { id: 1, image: '/assets/img/brand_img01.png' },
      { id: 2, image: '/assets/img/brand_img02.png' },
      { id: 3, image: '/assets/img/brand_img03.png' },
      { id: 4, image: '/assets/img/brand_img04.png' },
      { id: 5, image: '/assets/img/brand_img05.png' },
      { id: 6, image: '/assets/img/brand_img02.png' },
    ];
  const testimonials = [
    {
      name: "David Anderson",
      position: "Supply Chain Director, Global Trade Solutions",
      rating: 5,
      comment: "MTL Ship has revolutionized our international shipping operations. Their expertise in handling complex logistics challenges and commitment to on-time delivery has significantly improved our supply chain efficiency."
    },
    {
      name: "Maria Rodriguez",
      position: "Operations Manager, TechForward Inc.",
      rating: 5,
      comment: "The team's attention to detail and proactive communication have made them an invaluable partner. Their real-time tracking system gives us complete visibility of our shipments worldwide."
    },
    {
      name: "James Wilson",
      position: "CEO, Oceanic Trading Co.",
      rating: 5,
      comment: "Working with MTL has been a game-changer for our business. Their innovative solutions and customer-first approach have helped us expand our operations across new markets with confidence."
    },
    {
      name: "Sarah Chen",
      position: "Logistics Coordinator, Asian Markets Ltd",
      rating: 5,
      comment: "MTL's expertise in handling sensitive cargo and their ability to navigate complex customs procedures have made them our preferred logistics partner in the region."
    }
  ];
  const [email, setEmail] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [modalMessage, setModalMessage] = useState('');
  const [modalType, setModalType] = useState('');
  const handleSubscribe = (e) => {
    e.preventDefault();
    if (!email || !email.includes('@')) {
      toast.error('Please enter a valid email address');
      return;
    }

    toast.success('Email successfully subscribed!');
    setEmail('');
  };
  const handlePrev = () => {
    setCurrentTestimonial((prev) => (prev === 0 ? testimonials.length - 1 : prev - 1));
  };
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  const handleNext = () => {
    setCurrentTestimonial((prev) => (prev === testimonials.length - 1 ? 0 : prev + 1));
  };

  const renderStars = (rating) => {
    return Array(rating).fill().map((_, index) => (
      <i key={index} className="fas fa-star" />
    ));
  };

  useEffect(() => {
    const interval = setInterval(() => {
      handleNext();
    }, 5000); // Her 5 saniyede bir otomatik geçiş

    return () => clearInterval(interval);
  }, []);

  return (
    <>
        <ToastContainer 
        position="bottom-center"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        style={{
          zIndex: 9999,
          fontSize: '14px',
          width: 'auto',
          maxWidth: '400px'
        }}
      />
      <div id="preloader" style={{ display: "none" }}>
        <div className="tg-preloader-block">
          <div className="tg-spinner-eff">
            <div className="tg-bar tg-bar-top" />
            <div className="tg-bar tg-bar-right" />
            <div className="tg-bar tg-bar-bottom" />
            <div className="tg-bar tg-bar-left" />
          </div>
        </div>
      </div>
      {/*Preloader-end */}
      {/* Scroll-top */}
      <button className="scroll__top scroll-to-target open" data-target="html" onClick={scrollToTop}>
        <i className="fas fa-angle-up" />
      </button>
      {/* Scroll-top-end*/}
      {/* header-area */}
      <HeaderBest/>
      {/* header-area-end */}
      {/* main-area */}
      <main className="fix">
        {/* breadcrumb-area */}
        <section
          className="breadcrumb__area breadcrumb__bg"
          data-background="assets/img/bg/breadcrumb_bg.jpg"
          style={{ backgroundImage: 'url("assets/img/breadcrumb_bg.jpg")' }}
        >
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="breadcrumb__content">
                  <h1 className="title">About Us</h1>
                  <nav className="breadcrumb">
                    <span property="itemListElement" typeof="ListItem">
                      <a href="/">Home</a>
                    </span>
                    <span className="breadcrumb-separator">
                      <i className="flaticon-right-arrow" />
                    </span>
                    <span property="itemListElement" typeof="ListItem">
                      About Us
                    </span>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* breadcrumb-area-end */}
        {/* about-area */}
        <section className="about__area-two section-py-120">
          <div className="container">
            <div className="row align-items-center justify-content-center gutter-24">
              <div className="col-lg-6 col-md-9">
                <div className="about__img-two">
                  <img
                    src="/assets/img/inner_about_img03.jpg"
                    alt="img"
      
           
                  />
                  <img
                    src="/assets/img/inner_about_img02.jpg"
                    alt="img"
      
                  />
                </div>
              </div>
              <div className="col-lg-6">
                <div className="about__content-two">
                  <div className="section__title section__title-two mb-20">
                    <span className="sub-title">About MTL Ship</span>
                    <h2 className="title">
                      Global Logistics Excellence: Your Trusted Partner in Supply Chain Solutions
                    </h2>
                  </div>
                  <p className="info-one">
                    MTL Ship stands as a premier global logistics provider, delivering comprehensive supply chain solutions across international markets. With our extensive network spanning multiple continents, we specialize in multimodal transportation, warehousing, and distribution services. Our commitment to innovation and operational excellence has positioned us as a leader in the logistics industry, serving diverse sectors with customized solutions.
                  </p>
                  <div className="about__content-inner">
                    <div className="about__list-box about__list-box-two">
                      <ul className="list-wrap">
                        <li>
                          <i className="flaticon-check" />
                          Advanced Tracking & Monitoring Systems
                        </li>
                        <li>
                          <i className="flaticon-check" />
                          Global Network Coverage
                        </li>
                        <li>
                          <i className="flaticon-check" />
                          Certified Professional Team
                        </li>
                        <li>
                          <i className="flaticon-check" />
                          Secure & Efficient Operations
                        </li>
                      </ul>
                    </div>
                    <div className="about__clients-box">
                      <span>Innovative Solutions for Global Trade!</span>
                      <div className="counter__item">
                        <div className="counter__icon">
                          <i className="flaticon-planet-earth" />
                        </div>
                        <div className="counter__content">
                          <h2 className="count">
                          Global Shipments Delivered
                          </h2>
                        
                        </div>
                      </div>
                    </div>
                  </div>
                  <p>
                    At MTL Ship, we combine cutting-edge technology with decades of industry expertise to provide reliable, efficient, and cost-effective logistics solutions. Our comprehensive service portfolio includes ocean freight, air cargo, road transportation, and warehousing services. We maintain the highest standards of quality and security throughout the supply chain, ensuring your cargo reaches its destination safely and on schedule. Our customer-centric approach and commitment to continuous improvement drive us to exceed expectations and deliver exceptional value to our clients worldwide.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* about-area-end */}
        {/* features-area */}
        <section className="features__area section-pb-90">
          <div className="container">
            <div className="row justify-content-center gutter-24">
              <div
                className="col-lg-4 col-md-6"
          
              >
                <div className="features__item">
                  <div className="features__icon">
                    <i className="flaticon-warehouse-1" />
                  </div>
                  <div className="features__content">
                    <h2 className="title">Warehouse</h2>
                    <p>
                      Our state-of-the-art warehousing solutions provide secure storage, efficient inventory management, and seamless distribution services for your cargo.
                    </p>
                    <h2 className="number">01</h2>
                  </div>
                </div>
              </div>
              <div
                className="col-lg-4 col-md-6 "
           
              >
                <div className="features__item">
                  <div className="features__icon">
                    <i className="flaticon-air-freight" />
                  </div>
                  <div className="features__content">
                    <h2 className="title">Air Freight</h2>
                    <p>
                      Fast and reliable air cargo services connecting major global destinations with competitive rates and real-time tracking capabilities.
                    </p>
                    <h2 className="number">02</h2>
                  </div>
                </div>
              </div>
              <div
                className="col-lg-4 col-md-6 "
        
              >
                <div className="features__item">
                  <div className="features__icon">
                    <i className="flaticon-ship" />
                  </div>
                  <div className="features__content">
                    <h2 className="title">Ship Cargo</h2>
                    <p>
                      Comprehensive ocean freight solutions offering cost-effective and environmentally friendly transportation for all types of cargo worldwide.
                    </p>
                    <h2 className="number">03</h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="features__shape">
            <img
              src="/assets/img/features_shape.png"
              alt="shape"
              data-aos="fade-left"
              data-aos-delay={400}
              className="aos-init"
            />
          </div>
        </section>
        {/* features-area-end */}
        {/* video-area */}
 

   
        {/* team-area-end */}
        {/* testimonial-area */}

        {/* testimonial-area-end */}

        {/* brand-area-end */}
      </main>
      {/* main-area-end */}
      {/* footer-area */}
      <footer className="footer__area fix">
        <div className="container">
          <div className="cta__wrap fix">
            <div className="row align-items-center">
              <div className="col-lg-7">
                <div className="cta__content">
                  <h3 className="title">
                    Fastest &amp; secure way to transport <br /> anything anytime
                  </h3>
                </div>
              </div>
              <div className="col-lg-5">
                <div className="cta__btn text-end">
                <Link to="/getoffer" className="btn btn-two">
                    Request a Quote{" "}
                    <svg
                      width={13}
                      height={13}
                      viewBox="0 0 13 13"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      data-inject-url="https://themeadapt.com/tf/logistex/assets/img/right_arrow.svg"
                      className="injectable"
                    >
                      <path
                        d="M1 12.0969L12.0969 0.999996M12.0969 0.999996H1M12.0969 0.999996V12.0969"
                        stroke="currentcolor"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M1 12.0969L12.0969 0.999996M12.0969 0.999996H1M12.0969 0.999996V12.0969"
                        stroke="currentcolor"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    </Link>
                </div>
              </div>
            </div>
            <div className="cta__shape">
              <img
                src="/assets/img/cta_shape.png"
                alt="img"
                data-aos="fade-up-right"
                data-aos-delay={400}
                className="aos-init"
              />
            </div>
          </div>
          <div className="footer__top">
            <div className="row">
              <div className="col-xl-4 col-lg-5 col-md-6">
                <div className="footer__widget">
                  <div className="footer__logo">
                  <Link to="/">
                        <img src="/assets/img/mtllogo.png" alt="Logo" />
                      </Link>
                  </div>
                  <div className="footer__content">
                    <p>
                    At MTL, we specialize in logistics solutions tailored to meet diverse delivery needs. 
                    </p>
                  </div>
                  <form onSubmit={handleSubscribe} className="footer__newsletter" style={{display: 'none'}}>
                    <div className="form-grp">
                      <input 
                        type="email" 
                        placeholder="enter your e-mail" 
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                      <button type="submit">Subscribe</button>
                    </div>
                    <span>We don't send you any spam</span>
                  </form>
                </div>
              </div>
              <div className="col-xl-2 col-lg-4 col-md-6 col-sm-6">
                <div className="footer__widget">
                  <h4 className="footer__widget-title">Our Services</h4>
                  <div className="footer__link">
                    <ul className="list-wrap">
                      <li>
                      <Link to="/">Home</Link>
                      </li>
                      <li>
                      <Link to="/aboutus">About Us</Link>
                      </li>
                      <li>
                      <Link to="/services">Services</Link>
                      </li>
                      <li>
                      <Link to="/blog">Blog</Link>
                      </li>
                      <li>
                      <Link to="/getoffer">Get Offer</Link>
                      </li>
                      <li>
                      <Link to="/contact">Contact</Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6">
                <div className="footer__widget">
                  <h4 className="footer__widget-title">Other Logistics Companies</h4>
                  <div className="footer__link">
                    <ul className="list-wrap">
                      <li>
                         <a href="https://mitlog.com.tr/">Mitlog Logistics</a>
                      </li>
                      <li>
                        <a href="https://www.mitlog-airsea.com.tr/">Mitlog Air&Sea Logistics</a>
                      </li>
                     
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-xl-3 col-lg-4 col-md-6">
                <div className="footer__widget">
                  <h4 className="footer__widget-title">Information</h4>
                  <div className="footer__info-wrap">
                    <ul className="list-wrap">
                      <li>
                        <i className="flaticon-location-1" />
                        <p>
                        8451 Market Street ste 138, <br /> Houston Texas 77029 , USA
                        </p>
                      </li>
                      <li>
                        <i className="flaticon-telephone" />
                        <a href="tel:+18325621002">(+1) 832 562 1002</a>
                      </li>
                      <li>
                        <i className="flaticon-time" />
                        <p>
                          Mon – Fri: 8.30- 17.30 EST 
                        </p>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="footer__bottom">
            <div className="row align-items-center">
              <div className="col-md-7">
                <div className="copyright-text">
                  <p>
                    Copyright @MTL | All Right
                    Reserved
                  </p>
                </div>
              </div>
              <div className="col-md-5">
                <div className="footer__social">
                  <ul className="list-wrap">
                  <li>
                        <a href="https://wa.me/18325621002" target="_blank">
                          <i className="fab fa-whatsapp" />
                        </a>
                      </li>
                      <li>
                        <a href="https://www.instagram.com/mtlshipinc" target="_blank">
                          <i className="fab fa-instagram" />
                        </a>
                      </li>
                
                  
                      <li>
                        <a href="https://www.linkedin.com/company/mtlship" target="_blank">
                          <i className="fab fa-linkedin-in" />
                        </a>
                      </li>
              <li/>
               
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="footer__shape">
          <img
            src="/assets/img/footer_shape01.png"
            alt="shape"
            data-aos="fade-down"
            data-aos-delay={400}
            className="aos-init"
          />
          <img
            src="/assets/img/footer_shape02.png"
            alt="shape"
            data-aos="fade-left"
            data-aos-delay={400}
            className="aos-init"
          />
        </div>
      </footer>
      {/* footer-area-end */}
      {/* JS here */}
    </>
  );
}

export default Aboutt;

